import Head from "next/head";
import { Fragment } from "react/cjs/react.production.min";
import { Disclosure, Transition } from "@headlessui/react";
import style from "./style.module.css";
import Image from "next/image";
import { useEffect, useState } from "react";
import Button from "@/components/UI/button/button";
import { useRouter } from "next/router";
import { useInView } from 'react-intersection-observer';
import { useMediaQueries } from "@react-hook/media-query";
import { smeReasons } from "@/helpers/constant/content_data";
import { className as cx } from "@/helpers/utility/class_name";

function Smes(props) {
  const router = useRouter()
  const [isVisibleCTA, setIsVisibleCTA] = useState(true)
  const { ref, inView, entry } = useInView({
    threshold: 0
  })

  const mobile = useMediaQueries({
    screen: "screen",
    min: "(min-width: 0px)",
    max: "(max-width: 1023px)",
  });
  const monitor = useMediaQueries({
    screen: "screen",
    min: "(min-width: 1024px)",
  });

  // Todo extract ease to components
  const easeIcons = [
    {
      id: 1,
      imageUrl: "/assets/icon-svg/overall-ease.svg",
      title: "แผนประกันภัยที่ครอบคลุมทุกความต้องการ",
    },
    {
      id: 2,
      imageUrl: "/assets/icon-svg/installment.svg",
      title: "ผ่อนได้ จ่ายสะดวกได้หลายช่องทาง",
    },
    {
      id: 3,
      imageUrl: "/assets/icon-svg/all-time.svg",
      title: "ปรึกษาฟรี! 24 ชั่วโมง",
    },
    {
      id: 4,
      imageUrl: "/assets/icon-svg/easy-claim.svg",
      title: "เคลมสะดวก ดูแลทุกผลประโยชน์ของคุณ",
    },
  ];


  useEffect(() => {
    document.querySelector('main').classList.add('w-overflow');
  }, [])

  useEffect(() => {
    if (inView) {
      setIsVisibleCTA(true)
    } else {
      setIsVisibleCTA(false)
    }
  }, [inView])

  const onClickHandler = () => {
    router.push('/smes/form/')
  }

  return (
    <Fragment>
      <Head>
        <title>ประกันภัยธุรกิจ SME กับ TQM Home</title>
      </Head>
      <div className={style.sme_page_container}>
        <section className={style.page_splash}>
          <div className={style.page_splash_bg}>
          {mobile.matchesAll && (
            <Image
              src="/assets/images/sme-bg-mobile.png"
              height="380"
              width="360"
              objectFit="contain"
              layout="responsive"
            />
          )}
          {monitor.matchesAll && (
            <Image
              src="/assets/images/sme-bg-desktop.png"
              height="402"
              width="1140"
              objectFit="contain"
              layout="responsive"
            />
          )}
          </div>
        </section>
        <section className={style.sme_details}>
          <div className={style.page_splash_content}>
            <h1 className={style.title_mobile}>ประกันภัยธุรกิจ SME กับ TQM Home</h1>
            <h1 className={style.title_notebook}>ประกันภัยธุรกิจรายย่อย (SME)</h1>
            <p>ประกันภัยคุ้มครองธุรกิจของคุณ ภัยธรรมชาติ ไฟฟ้าลัดวงจร โจรกรรม น้ำท่วม การสูญเสียรายได้ เพื่อให้ธุรกิจสามารถดำเนินต่อได้ไม่สะดุด แม้เกิดเหตุไม่คาดคิด</p>
            <div className={style.ease_items}>
              <ul className={style.ease_items_container}>
                {easeIcons.map(ease => (
                  <li className={style.ease_item} key={ease.id}>
                    <div className={style.ease_icon}>
                      <Image src={ease.imageUrl} layout="fill" objectFit="contain" />
                    </div>
                    <h4>{ease.title}</h4>
                  </li>
                ))}
              </ul>
            </div>
            <div className={style.button_wrapper} ref={ref}>
              <Button color="blue" text="สนใจทำประกัน" onClick={onClickHandler} />
            </div>
          </div>
          <Disclosure defaultOpen={true}>
            {({ open }) => (
              <Fragment>
                <Disclosure.Button className={style.disclosure_button}>
                  <div className={style.disclosure_head}>
                    <p>SME (Small Medium Enterprise)</p>
                    {!open && (
                      <>
                        <div className={style.toggle_btn_img}>
                          <Image
                            src="/assets/icon-svg/arr-down-blue.svg"
                            width={25}
                            height={25}
                            layout="fixed"
                          />
                        </div>
                      </>
                    )}
                    {open && (
                      <>
                        <Image
                          src="/assets/icon-svg/arr-up-blue.svg"
                          width={25}
                          height={25}
                          layout="fixed"
                        />
                      </>
                    )}
                  </div>
                </Disclosure.Button>
                <Transition
                  show={open}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scaleY-95 opacity-0"
                  enterTo="transform scaleY-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scaleY-100 opacity-100"
                  leaveTo="transform scaleY-95 opacity-0"
                >
                  <Disclosure.Panel className={style.disclosure_panel}>
                    <div className={style.sme_description}>
                      <p>
                        รูปแบบธุรกิจในโลกปัจจุบันมีการเปลี่ยนแปลงไป ผู้คนสนใจทำธุรกิจส่วนตัวกันมากขึ้น
                        และที่เป็นที่นิยมมากที่สุดคือ ธุรกิจขนาดย่อม หรือขนาดกลาง (SME) ตามกำลังของผู้ประกอบการ
                        โดยใช้เงินลงทุนจำนวนไม่สูงและสามารถเป็นเจ้านายตัวเองได้คนรุ่นใหม่นิยมทำธุรกิจ SME
                        เพราะให้ความสบายใจและไม่กดดันในการทำงาน แน่นอนว่าการเริ่มต้นทำธุรกิจ SME ต้องมีการเตรียมพร้อมสิ่งกับต่าง ๆ
                        หลายอย่าง เช่น เรื่องงบประมาณค่าใช้จ่าย การเรียนรู้การตลาดของธุรกิจที่กำลังลงมือทำและสิ่งที่สำคัญที่ไม่ควรมองข้ามอีกประการ
                        คือการทำประกันสำหรับธุรกิจ SME
                      </p>
                      <p>
                        การทำประกันภัยถือเป็นการลดภาระค่าใช้จ่ายในหลายมิติ เช่น
                        ในกรณีที่สถานประกอบการเกิดเหตุเพลิงไหม้ หรือ น้ำท่วม
                        นอกจากค่าใช้จ่ายในการซ่อมแซมตัวอาคารและปรับปรุงภายในอาคารแล้วในระหว่างที่กำลังซ่อมแซมทรัพย์สินนั้น
                        ผู้ประกอบการอาจจะไม่สามารถดำเนินธุรกิจได้เป็นระยะเวลาหนึ่ง
                        ซึ่งจะทำให้ขาดรายได้จากการที่ไม่สามารถดำเนินธุรกิจตามปกติได้กรมธรรม์ประกันภัยถือเป็นอีกหนึ่งเครื่องมือในการบริหารจัดการความเสี่ยงในการประกอบธุรกิจ
                        ดังนั้นความรู้ความเข้าใจเกี่ยวกับความคุ้มครอง เงื่อนไขและข้อยกเว้นตามกรมธรรม์ประกันภัยของผู้ประกอบการ
                        จึงเป็นสิ่งสำคัญ เนื่องจากสัญญาประกันภัยให้ความคุ้มครองที่แตกต่างหลากหลาย
                      </p>
                      <p>
                        ผู้ประกอบการควรเข้าใจความเสี่ยงภัยที่ท่านกำลังเผชิญเข้าใจเงื่อนไขและข้อยกเว้นในกรมธรรม์ก่อนตัดสินใจเลือกซื้อ
                        อย่างไรก็ตามเพื่อเป็นทางเลือกให้แก่ผู้ประกอบการท่านสามารถเลือกใช้บริการจากที่ปรึกษาด้านการประกันภัยผู้มีความเชี่ยวชาญเฉพาะ
                        อย่าง TQM Insurance Broker เพื่อดูแลเรื่องการประกันภัยให้ท่านอย่างมืออาชีพ
                      </p>
                      <b>
                        เกณฑ์ในการพิจารณารับประกันภัยสำหรับธุรกิจ SME แยกตามขนาดของสินทรัพย์ ตั้งแต่มูลค่า 2 ล้านบาท - 50 ล้านบาท
                      </b>
                    </div>
                  </Disclosure.Panel>
                </Transition>
              </Fragment>
            )}
          </Disclosure>
          <hr/>
          <div className={style.sme_coverage_details}>
            <h3 className={style.title}>ทำไมต้องเลือกความคุ้มครองประกันภัยธุรกิจ SME ผ่าน TQM Home</h3>
            <p>บริษัทฯ จัดหาความคุ้มครองที่เหมาะสมให้แก่ธุรกิจ SME โดยสรุปมีดังต่อไปนี้</p>
            {smeReasons.map((reason, index) => (
              <div key={index} className={style.sme_coverage_details_item}>
                <div className={style.coverage_picture}>
                  <Image
                    src={reason.image}
                    height="120"
                    width="120"
                    objectFit="contain"
                    layout="responsive"
                  />
                </div>
                <p>{reason.title}</p>
              </div>
            ))}
          </div>
        </section>
        <section className={`${style.sme_button_container} ${isVisibleCTA ? "hidden-sticky" : ""}`}>
          <Button color="blue" text="สนใจทำประกัน" onClick={onClickHandler} />
        </section>
      </div>
    </Fragment>
  )
}

export default function Page(props) {
  return <Smes {...props} />;
}
